import React from 'react';
import Icon from '../../../components/Icons';
import { BasicDropdown } from '../../../components';

const Actions = ({ handleClick, disabled, isArial = false, item = null }) => {
  const actions = () => {
    const authorizedActions = [];

    authorizedActions.push({
      icon: <Icon icon="search" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'show_document',
      props: {
        onClick: () => handleClick(item, 'show_document')
      },
      title: 'Ver Documento'
    });

    authorizedActions.push({
      icon: <Icon icon="search" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'generate_document',
      props: {
        onClick: () => handleClick(item, 'generate_document')
      },
      title: 'Generar Documento'
    });

    authorizedActions.push({
      icon: <Icon icon="search" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'summary',
      props: {
        onClick: () => handleClick(item, 'show_settlement')
      },
      title: 'Ver Resumen'
    });

    authorizedActions.push({
      icon: <Icon icon="pencil" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'edit',
      props: {
        onClick: () => handleClick(item, 'edit'),
        disabled
      },
      title: 'Editar'
    });
    authorizedActions.push({
      icon: <Icon icon="download-2" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'download',
      props: {
        onClick: () => handleClick(item, 'download'),
        disabled
      },
      title: 'Descargar'
    });

    authorizedActions.push({
      icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'destroy',
      props: {
        onClick: () => handleClick(item, 'destroy'),
        disabled
      },
      title: 'Eliminar'
    });

    return authorizedActions;
  };

  return (
    <div className="d-flex">
      <BasicDropdown
        block
        items={actions()}
        noArrow
        right
        titleDrop={
          <span className={`align-middle ${isArial ? 'arial-dt' : ''}`}>
            Acciones <Icon icon="ellipsis-vertical" height="20px" width="20px" />
          </span>
        }
        variant="outline-primary"
      />
    </div>
  );
};

export default Actions;
